import { render } from "./TrailerDamageLayout.vue?vue&type=template&id=3dbd9ea5&scoped=true&ts=true"
import script from "./TrailerDamageLayout.vue?vue&type=script&lang=ts"
export * from "./TrailerDamageLayout.vue?vue&type=script&lang=ts"

import "./TrailerDamageLayout.vue?vue&type=style&index=0&id=3dbd9ea5&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbd9ea5"]])

export default __exports__